const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  stepNumber: 1,
  addNewproductData: null,
  redirected: true,
  step1Data: null,
  step2Data: null,
  changeTextData: null,
  changeImageData: null,
  categoryData: null,
  selectedCategoryData: null,
  step3Data: [],
  campaignOrderId: null,
  step4Data: {
    id: 1,
    name: "starter",
    img1: "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/starter-logo.svg",
    img2: "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/starter.svg",
    price: 7500,
    people: "1,00,000",
  },
  coords: null,
  location: null,
  radius: 10,
  geocoder: null,
  autocomplete: null,
  budgetdata: null,
  total: null,
  loadingSpinner: null,
  searchLocationInput: false,
  isstep3DataLoading: false,
};

const stepsSlice = createSlice({
  name: "steps",
  initialState,
  reducers: {
    handleStepNumber(state, action) {
      state.stepNumber = action.payload;
    },
    handleSetRadius(state, action) {
      state.radius = action.payload;
    },
    handleSetAutoComplete(state, action) {
      state.autocomplete = action.payload;
    },
    handleSetGeocoder(state, action) {
      state.geocoder = action.payload;
    },
    handleAddNewproductData(state, action) {
      state.addNewproductData = action.payload;
    },
    handleRedirection(state, action) {
      state.redirected = action.payload;
    },
    step1(state, action) {
      state.step1Data = action.payload;
    },
    step2(state, action) {
      state.step2Data = action.payload;
    },
    changeText(state, action) {
      state.changeTextData = action.payload;
    },
    changeImage(state, action) {
      state.changeImageData = action.payload;
    },
    category(state, action) {
      state.categoryData = action.payload;
    },
    selectedCategory(state, action) {
      state.selectedCategoryData = action.payload;
    },
    step3(state, action) {
      const newCard = action.payload;
      const existingCard = state.step3Data.find((card) => card.id === newCard.id);
      if (existingCard) {
        state.step3Data = state.step3Data.filter((card) => card.id !== newCard.id);
      } else {
        state.step3Data.push(action.payload);
      }
    },
    step4(state, action) {
      state.step4Data = action.payload;
    },
    setCoords(state, action) {
      state.coords = action.payload;
    },
    setLocation(state, action) {
      state.location = action.payload;
    },
    setBudgetData(state, action) {
      state.budgetdata = action.payload;
    },
    setTotal(state, action) {
      state.total = action.payload;
    },
    setCampaignOrderId(state, action) {
      state.campaignOrderId = action.payload;
    },
    handleLoadingSpinner(state, action) {
      state.loadingSpinner = action.payload;
    },
    handleSearchLocationInput(state, action) {
      state.searchLocationInput = action.payload;
    },
    setIsS3dataLoading(state, action) {
      state.isstep3DataLoading = action.payload;
    },
    resetSteps: (state) => {
      state = initialState;
      return {
        ...initialState,
      };
    },
  },
});

export const stepsActions = stepsSlice.actions;
export default stepsSlice;
